/**
 * 节点画布素材读取工具。
 *
 * 非 React Hook 场景使用，例如节点定义里的 getSize 无法调用 useNodeAsset，
 * 只能根据节点 data.assetRefs 直接读取当前 canvas-assets store。
 */
import { canvasAssetsStore } from '../model/canvas-assets-store';
import type { CanvasAsset } from '../model/canvas-asset-types';
import { readAssetRefsValue } from './node-asset-refs';

/**
 * 读取节点引用的第一个画布素材。
 *
 * @param nodeData 节点自定义数据，至少可能包含 assetRefs
 * @returns 第一个 assetRef 对应的 CanvasAsset；无引用或素材缺失时返回 undefined
 */
export function readFirstNodeCanvasAsset(nodeData: Record<string, unknown>): CanvasAsset | undefined {
  const assetId = readAssetRefsValue(nodeData.assetRefs)[0];
  return assetId ? canvasAssetsStore.assets.get(assetId) : undefined;
}
